import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormLabel, Tooltip, Typography } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import RenameIcon from "../../style/rename.svg";
import EditResend from "../../style/edit_resend.svg";
import DeleteIcon from "../../style/delete.svg";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import DraftsIcon from "@mui/icons-material/Drafts";
import TemplatePreviewAndSign from "../../components/TemplatePreviewAndSign";
import { useMessage } from "../../components/Header";
import { Link } from "react-router-dom";
import Icon from "../../components/Icons/Icon";
import { deleteTemplate, getTemplates, getFile } from "./Function";
import useStyles from "./Style";
import Loading from "../../components/Progress/Loading";
import SearchTemplates from "../../components/Common/SearchTemplates";
import RangeDatePickerTemplate from "../../components/Common/RangeDatePickerTemplate";
import { MoreVerticalIcon } from "lucide-react";
import { useTheme } from "../../style/theme";
import { useTheme as useThemee } from "@mui/material/styles";
import { Card, CardContent, Chip, useMediaQuery } from "@mui/material";
import DateFormate from "../../components/Common/DateFormate";
const Index = (props) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [document, setDocument] = useState("");
  const [rows, setRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [templateId, setTemplateId] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const { showError, showSuccess } = useMessage();
  const [signDocument] = useState(false);
  const getRowId = (row) => row._id;
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
    endDate: new Date(),
  });
  const lastFiveYearDate = new Date(
    new Date().setFullYear(new Date().getFullYear() - 5)
  );
  const { startDate, endDate } = selectedDateRange;

  const onChangeHandleDatepicker = (dateStrings) => {
    if (dateStrings) {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: dateStrings[0],
        endDate: dateStrings[1],
      });
    } else {
      setSelectedDateRange({
        ...selectedDateRange,
        startDate: new Date(lastFiveYearDate),
        endDate: new Date(),
      });
    }
  };
  const handleClick = (event, id) => {
    // console.log(event);
    // console.log("templateId", id);
    setTemplateId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const columns = [
    {
      field: "templateName",
      headerName: "TITLE",
      flex: 4,
      minWidth: 300,
      editable: true,
    },
    {
      field: "createdAt",
      headerName: "Date Created",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,
    },
    {
      field: "userName",
      headerName: "Created By",
      flex: 1, // Takes 1 part of available space
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1, // Takes 1 part of available space
      minWidth: 150, // Center header
      align: "center",
      renderCell: (params) => (
        <div>
          <Tooltip title="click to see all Options">
            <Button
              aria-describedby={id}
              variant="text"
              onClick={(event) => handleClick(event, params.row._id)}
            >
              <MoreVerticalIcon />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  const fetchFile = async (fileId) => {
    try {
      const response = await getFile(fileId);
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const url = URL.createObjectURL(blob);
        setPdfFile(url);
      }
    } catch (e) {
      // console.error("Error fetching data:", e);
    }
  };

  const handleDeleteTemplate = async () => {
    if (templateId) {
      await deleteTemplate(
        templateId,
        handleClose,
        fetchData,
        showError,
        showSuccess
      );
    } else {
      showError("Error template not deleted!");
    }
  };

  const fetchData = async () => {
    try {
      const response = await getTemplates();
      if (response.status === 200) {
        setRows(response.data.data); // Update the rows state with API data
        setFilteredRows(response.data.data);
        setIsLoading(false);
      }
    } catch (e) {
      // console.error("Error fetching data:", e);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch data when the component mounts
  }, []);

  const isEmpty = rows.length === 0;
  const handleChange = (event) => {
    setDocument(event.target.value);
  };
  const onChangeSearchHandller = (event) => {
    const { value } = event.target;
    // Filter rows based on the search input
    const filteredData = rows.filter((row) =>
      row.templateName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRows(filteredData);
  };

  useEffect(() => {
    const filtered = rows.filter((row) => {
      const d = new Date(row.createdAt);
      return d >= new Date(startDate) && d <= new Date(endDate);
    });
    setFilteredRows(filtered);
  }, [rows, startDate, endDate]);
  const theme = useTheme();

  const themee = useThemee();
  const isMobile = useMediaQuery(themee.breakpoints.down("sm"));
  //  const handleRowClick = (row) => {
  //     setDocumentRowId(row._id);
  //     setDocumentRow(row);
  //     setDocumentType(row.status);
  //     if (row.fileId) {
  //       setFileName(row.fileName);
  //       // fetchFile(row.fileId); // Uncomment this when implemented
  //     }
  //   };
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          mt: 2,
          boxShadow: "none",
          border: `1px solid ${theme.mode === "dark" ? "#292929" : "#D6D6D6"}`,
          padding: { xs: 0, sm: 3 },
          borderRadius: 2,
        }}
      >
        {isLoading && <Loading />}
        {signDocument && (
          <Grid item xs={12} sm={12}>
            <TemplatePreviewAndSign pdfFile={pdfFile}></TemplatePreviewAndSign>
          </Grid>
        )}
        <Typography
          variant="h6"
          sx={{ paddingTop: { xs: 3, sm: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          Templates
        </Typography>
        <br />
        <Typography
          variant="body2"
          sx={{
            paddingTop: { xs: 0, sm: 0 },
            paddingLeft: { xs: 3, sm: 0 },
            paddingRight: { xs: 3, sm: 0 },
          }}
          style={{ color: "#7d8d98" }}
          className="text-wrap"
        >
          Templates are reusable documents that you send often. Create a
          template once to allow you to send your documents faster.{" "}
        </Typography>
        <br />
        <Grid
          container
          justifyContent={"space-between"}
          spacing={2}
          sx={{ paddingTop: { xs: 0 }, paddingLeft: { xs: 3, sm: 0 } }}
        >
          <SearchTemplates onChangeSearchHandller={onChangeSearchHandller} />
          <RangeDatePickerTemplate
            handleDateChange={onChangeHandleDatepicker}
          />
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sx={{ marginTop: "25px" }}>
            <div className={classes.root}>
              {isEmpty ? (
                <Box
                  sx={{
                    border: "1px solid #424242",
                    height: "200px",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 3,
                  }}
                >
                  <DraftsIcon sx={{ fontSize: 40, mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    No matches found for your current search.
                  </Typography>
                  <Link to="/templates/new" style={{ textDecoration: "none" }}>
                    <Tooltip title="Create new template">
                      <Button variant="contained" sx={{ mt: 1 }}>
                        Create Template
                      </Button>
                    </Tooltip>
                  </Link>
                </Box>
              ) : isMobile ? (
                // Mobile Card View
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    paddingTop: 3,
                    paddingBottom: 3,
                    paddingRight: 0.5,
                    paddingLeft: 0.5,
                  }}
                >
                  {filteredRows.map((row) => {
                    return (
                      <Card
                        key={getRowId(row)}
                        sx={{
                          cursor: "pointer",
                          boxShadow: 3,
                          "&:hover": { boxShadow: 6 },
                          border: `1px solid ${
                            theme.mode === "dark" ? "#292929" : "#D6D6D6"
                          }`,
                          borderLeft: `4px solid gray`,
                          borderRadius: 2,
                          "&:hover": { boxShadow: 6 },
                        }}
                        // onClick={() => handleRowClick(row)}
                      >
                        <CardContent>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {row.fileName}
                              </Typography>
                            </Box>
                            <IconButton
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClick(e, row);
                              }}
                              sx={{ ml: 1 }}
                            >
                              <MoreVerticalIcon />
                            </IconButton>
                          </Box>

                          {/* <Chip
                            label={row.status}
                            size="small"
                            sx={{
                              backgroundColor: statusColors.bg,
                              color: statusColors.text,
                              mt: 1,
                              fontSize: "0.75rem",
                              fontWeight: 600,
                            }}
                          /> */}

                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              mt: 2,
                              gap: 2,
                            }}
                          >
                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                Date Created
                              </Typography>
                              <Typography variant="body2">
                                <DateFormate localFormate={row.createdAt} />
                              </Typography>
                            </Box>

                            <Box>
                              <Typography
                                variant="caption"
                                display="block"
                                color="textSecondary"
                              >
                                Created By
                              </Typography>
                              <Typography variant="body2">
                                {row.userName}
                              </Typography>
                            </Box>
                          </Box>

                          {row.status === "Folder" && (
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{ mt: 2 }}
                              onClick={(e) => {
                                e.stopPropagation();
                                // onDoubleClickFOlderHandller(
                                //   row._id,
                                //   row.fileName
                                // );
                              }}
                            >
                              Open Folder
                            </Button>
                          )}

                          {/* <Box
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                              mt: 1,
                            }}
                          >
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClick(e, row);
                              }}
                            >
                              Actions
                            </Button>
                          </Box> */}
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              ) : (
                // Desktop DataGrid View
                <DataGrid
                  rows={filteredRows}
                  columns={columns}
                  getRowId={getRowId}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[10]}
                  checkboxSelection
                  disableSelectionOnClick
                  disableColumnReorder={true}
                  onRowClick={(params) => {
                    if (params.row.fileId) {
                      // fetchFile(params.row.fileId); // Pass _id to fetchFile
                    }
                  }}
                />
              )}

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Stack direction="column" spacing={3} width={170}>
                  <FormControl id="buttonsID">
                    <Link to={`/templates/${templateId}`}>
                      <IconButton
                        id="drag1"
                        aria-label="add"
                        style={{
                          border: "1px solid #eee",
                          "border-radius": "0px",
                          width: "100%",
                        }}
                      >
                        <FormLabel>
                          <img src={EditResend} alt="React Logo" />{" "}
                        </FormLabel>
                        <FormLabel style={{ "padding-left": "10px" }}>
                          Edit
                        </FormLabel>
                      </IconButton>
                    </Link>
                    <Link to={`/templates/${templateId}`}>
                      <IconButton
                        id="drag1"
                        aria-label="add"
                        style={{
                          border: "1px solid #eee",
                          "border-radius": "0px",
                          width: "100%",
                        }}
                      >
                        <FormLabel>
                          <img src={RenameIcon} alt="React Logo" />{" "}
                        </FormLabel>
                        <FormLabel style={{ "padding-left": "10px" }}>
                          Rename
                        </FormLabel>
                      </IconButton>
                    </Link>

                    {/* 
                                    <IconButton
                                        id='drag1'
                                        aria-label='add'
                                        style={{
                                            border: '1px solid #eee',
                                            'border-radius': '0px',
                                            width: '100%',
                                        }}
                                    >
                                        <FormLabel>
                                        <Icon
                                                name='/extension/general/archive.png'
                                                sx={{width:'1rem'}}
                                            />
                                        </FormLabel>
                                        <FormLabel
                                            style={{ 'padding-left': '10px' }}
                                        >
                                            Duplicate
                                        </FormLabel>
                                    </IconButton>
                                     */}
                    {/* 
                                    <IconButton
                                        id='drag1'
                                        aria-label='add'
                                        style={{
                                            border: '1px solid #eee',
                                            'border-radius': '0px',
                                            width: '100%',
                                        }}
                                    >
                                        <FormLabel>
                                            <Icon
                                                name='folder.png'
                                                sx={{width:'1rem'}}
                                            />
                                        </FormLabel>
                                        <FormLabel
                                            style={{ 'padding-left': '10px' }}
                                        >
                                            Move to
                                        </FormLabel>
                                    </IconButton>
                                     */}
                    <IconButton
                      id="drag5"
                      aria-label="add"
                      style={{
                        border: "1px solid #eee",
                        "border-radius": "0px",
                        width: "100%",
                      }}
                      onClick={handleDeleteTemplate}
                    >
                      <img src={DeleteIcon} alt="React Logo" />{" "}
                      <FormLabel style={{ "padding-left": "10px" }}>
                        Delete
                      </FormLabel>
                    </IconButton>
                  </FormControl>
                </Stack>
              </Popover>
            </div>
          </Grid>
        </Grid>
      </Box>
      <div className="im-divider"></div>
    </>
  );
};

export default Index;
